import { useState, useRef, useEffect, useCallback } from "react";
export const useSearchDropdown = (props) => {
    // State
    const [_, setRender] = useState([]);
    const [value, setValue] = useState("");
    // Ref
    const valueRef = useRef(props.options?.defaultValue || "");
    useEffect(() => {
        initValue();
        if (props.options?.setFirstItemAsDefaultValue && props.FUI.items?.length) {
            const firstItem = props.FUI.items[0];
            if (firstItem) {
                props.FUI.onChange?.(null, { ...props.FUI, value: firstItem });
                valueRef.current = firstItem.header;
                setValue("");
            }
        }
    }, [props.options?.defaultValue, props.options?.setFirstItemAsDefaultValue, props.FUI.items]);
    const initValue = useCallback(() => {
        if (!props.options?.defaultValue)
            return;
        valueRef.current = props.options?.defaultValue;
        setRender([]);
    }, [props.options?.defaultValue]);
    const changeSearchQuery = (_, data) => setValue(data.searchQuery);
    const onChange = (event, data) => {
        props.FUI.onChange(event, data);
        valueRef.current = data.value?.header;
        if (props.options?.resetValue)
            setValue("");
    };
    return { changeSearchQuery, value, onChange, valueRef: valueRef.current };
};
